import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./index.css";
import * as Sentry from "@sentry/vue";
import { persistSelectionState } from "./stores/game";
import { initLanguage } from "./composables/useText.js";

const app = createApp(App);
const pinia = createPinia();

pinia.use(({ store }) => {
  if (store.$id !== "game") return;
  store.$subscribe(
    (_mutation, state) => {
      persistSelectionState(state);
    },
    { detached: true },
  );
});

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const isDev = import.meta.env.DEV;

if (!isDev && sentryDsn) {
  Sentry.init({
    app,
    dsn: sentryDsn,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

app.use(pinia);
app.use(router);

initLanguage().then(() => {
  app.mount("#app");
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(
      `${import.meta.env.BASE_URL}sw.js`
    );
  });
}
